import { useState, Fragment } from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { useRouter } from 'next/router'

import * as colors from 'config/theme/colors'

import useTranslate from '../hooks/useTranslate'
import VisuallyHidden from '@reach/visually-hidden'
import SearchBar from 'components/SearchBar'

const Container = styled.div`
  display: block;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
`

const InputContainer = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 40px;
`

const ErrorText = styled.p`
  color: ${colors.errorTextColor};
  font-size: 12px;
  margin: 5px 0 0 0;
`

const IdapsDrugSearch = (props) => {
  const translate = useTranslate()
  const router = useRouter()

  const { onSectionLoad, drugs, parentPathName, pathKey, publicNameKey = 'name' } = props
  const [submitted, setSubmitted] = useState()
  const [value, setValue] = useState('')
  const [error, setError] = useState()

  const minSearchLength = 3

  const handleChange = (val) => {
    setValue(val)
    setSubmitted(false)
  }

  const handleSubmit = () => {
    setSubmitted(true)


    let lowerCasedValue = value.toLowerCase()
    const matchedDrug = _.find(drugs, drug => {
      if (publicNameKey === 'name' || !drug[publicNameKey]) {
        return drug.nameLower === lowerCasedValue
      } else {
        return drug[publicNameKey] === value
      }
    })
    const encodedPath = encodeURIComponent(matchedDrug[pathKey])

    if (!!matchedDrug) {
      setError(undefined)
      router.push({
        pathname: `/${parentPathName}/${encodedPath}`,
      })
    } else {
      return setError('SEARCH_MED_INVALID_ENTRY_ERROR')
    }
    
  }

  const id = 'idaps_product_lookup'
  const errorId = `${id}_error`
  const isInvalid = submitted && _.isString(error)

  let searchItems = drugs.map(item => {
    const name = item[publicNameKey] || item.name
    const section = _.capitalize(_.startCase(item.productCategory)) || 'Other'
    return {
      ...item,
      id: item.id,
      label: name,
      section
    }
  })

  return (
    <Fragment>
      <Container>
        <InputContainer>
          <label htmlFor={'search-idaps-drug-input'}>
            <VisuallyHidden>{translate('SEARCH_IDAPS_DRUG_INPUT_LABEL')}</VisuallyHidden>
          </label>
          <SearchBar
            id={id}
            submitOnEnter
            autoComplete
            value={value}
            placeholder={translate('SEARCH_IDAPS_DRUG_PLACEHOLDER')}
            items={searchItems}
            onSubmit={handleSubmit}
            errorId={errorId}
            isInvalid={isInvalid}
            onChange={(value) => handleChange(value)}
            minSearchLength={minSearchLength}
            onSectionLoad={(sections) => onSectionLoad(sections)}
          />
          {isInvalid && (
            <ErrorText id={errorId}><p>{translate('SEARCH_IDAPS_DRUG_ERROR')}</p></ErrorText>
          )}
        </InputContainer>
      </Container>
    </Fragment>
  )
}

export default IdapsDrugSearch
